var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { FeaturesListComponent } from '@ibe.components/shared/flight-brand-features-list/features-list.component';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { EXTRAS_ANCILLARY_BAG, EXTRAS_ANCILLARY_FAST_TRACK, EXTRAS_ANCILLARY_LOUNGE, EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_ANIMAL, EXTRAS_ANCILLARY_MEAL, EXTRAS_ANCILLARY_SEAT, SESSION_VAR_KEY_CURRENCY, EXTRAS_ANCILLARY_PREF_BOARD, SSR_CODE_MEAL_SKIP } from '@ibe.config';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAGoogleAnalyticsService, EVENT_ACTION_CLICK } from '@ibe.services/google.analytics.indra.service';
import { ModalService } from '@ibe/services/ui';
import { INDRAPackModalComponent } from '../bundles-modal/pack-modal.indra.component';
import { Bundles } from '@ibe.components/booking/extras/bundles/bundles';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { INDRAPackService } from '../sidebar-views/ancillaries/pack/pack.service.indra';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var INDRAFeaturesListComponent = /** @class */ (function (_super) {
    __extends(INDRAFeaturesListComponent, _super);
    // Corp
    // isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
    // isCorporate: boolean;
    // promotype: string;
    function INDRAFeaturesListComponent(store, bfmStorage, ancillariesShoppingCart, bookingService, gaService, packService, modalService, ibeAdminService) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.bfmStorage = bfmStorage;
        _this.ancillariesShoppingCart = ancillariesShoppingCart;
        _this.bookingService = bookingService;
        _this.gaService = gaService;
        _this.packService = packService;
        _this.modalService = modalService;
        _this.ibeAdminService = ibeAdminService;
        _this.payWithMiles = false;
        _this.state = 'collapsed';
        _this.hasUnaccompaniedMinor = false;
        _this.allAreUnaccompaniedMinor = false;
        _this.addFeature = new EventEmitter();
        _this.detailsFeature = new EventEmitter();
        _this.passengerIncluded = new EventEmitter();
        _this.flight_packs = [];
        _this.primaryFeaturesCount = 0;
        _this.secondaryFeaturesCount = 0;
        _this.totalFeaturesCount = 0;
        _this.see_more_secondary = 'see-less';
        _this.activeBookedTrip = null;
        _this.ancillariesPrices = null;
        _this.filteredPrimaryFeatures = [];
        _this.featuresLoaded = false;
        _this.allSubscriptions = [];
        _this.prevCurrentPacks = [];
        _this.seeMoreDisplayed = false;
        _this.ancillariesAddedToPayWithMiles$ = _this.store.select(fromStore.getAncillariesAddedToPayWithMiles);
        return _this;
    }
    Object.defineProperty(INDRAFeaturesListComponent.prototype, "features", {
        set: function (data) {
            this._features = Object.assign([], data);
        },
        enumerable: true,
        configurable: true
    });
    INDRAFeaturesListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.INDRA_loadFeatures();
        this.activeBookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
        this.shoppingCartSubscription = this.ancillariesShoppingCart.INDRA_getAncillariesShoppingCart(this.activeBookedTrip.data.pnr).subscribe(function (result) {
            if (_this.flight) {
                _this.featuresAdded = result.itemsAdded.filter(function (item) {
                    return item.enabled === true && (item.flightCardId === _this.flight.details.assignedFlightId.toString());
                });
                var packs = _this.bfmStorage.INDRA_getAncillariesPacks();
                _this.bundle = new Bundles(_this.flight, packs, _this._features, _this.featuresAdded);
            }
        });
        this.INDRA_getExtrasPrices();
        if (this.activeBookedTrip['ancillaries-data']) {
            this.itemsCurrencyCode = this.activeBookedTrip['ancillaries-data']['bundleList'].filter(function (bundle) { return bundle.ancillaryList.length && bundle.ancillaryList[0].catalog; })[0].ancillaryList[0].catalog[0].passengers[0].codeList[0].currency;
        }
        if (this.flight_packs.length > 0) {
            this.packSubscription = this.packService.currentPacks.subscribe(function (value) {
                if (value.length) {
                    //A pack has been deselected
                    if (_this.prevCurrentPacks.length > value.length) {
                        _this.prevCurrentPacks.filter(function (pack) { return !value.some(function (pck) { return pck.flightId == pack.flightId && pck.type == pack.type; }); }).forEach(function (pck) {
                            pck.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(function (feature) {
                                var element = document.getElementById(feature.type + "_" + pck.flightId);
                                if (element) {
                                    element.style.display = '';
                                }
                            });
                        });
                        _this.prevCurrentPacks = value;
                        //A pack has been selected
                    }
                    else {
                        // Checks if a ancillary included in the pack could be purchased for other segment, and hides ancillaries that can't be purchased
                        _this.INDRA_ancillariesWhitelist(value, _this.flightId, _this.activeBookedTrip["ancillaries-data"].bundleList);
                        _this.prevCurrentPacks = value;
                    }
                }
                else {
                    //A pack has been deselected
                    if (_this.prevCurrentPacks.length > value.length) {
                        _this.prevCurrentPacks.filter(function (pack) { return !value.some(function (pck) { return pck.flightId == pack.flightId && pck.type == pack.type; }); }).forEach(function (pck) {
                            pck.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(function (feature) {
                                var element = document.getElementById(feature.type + "_" + pck.flightId);
                                if (element) {
                                    element.style.display = '';
                                }
                            });
                        });
                        _this.prevCurrentPacks = value;
                    }
                }
            });
        }
        this.allSubscriptions.push(this.packSubscription);
        this.allSubscriptions.push(this.shoppingCartSubscription);
    };
    INDRAFeaturesListComponent.prototype.INDRA_showPromoText = function () {
        var translation = this.ibeAdminService.getTranslationValue('bookingDetails.text.sale');
        if ('bookingDetails.text.sale' === translation || translation === "") {
            // No translation value on IBEAdmin
            return false;
        }
        else {
            return true;
        }
    };
    /**
     * Toggle the expanded/collapsed state;
     */
    INDRAFeaturesListComponent.prototype.handleToggle = function () {
        if (this.state === 'expanded') {
            this.state = 'collapsed';
        }
        else {
            this.state = 'expanded';
        }
    };
    /**
     * Toggle the expanded/collapsed state;
     */
    INDRAFeaturesListComponent.prototype.openToggle = function () {
        if (this.state === 'collapsed') {
            this.state = 'expanded';
        }
    };
    /**
     * Toggle the expanded/collapsed state;
     */
    INDRAFeaturesListComponent.prototype.handleExtrasSeeMoreToggle = function () {
        if (this.see_more_secondary === 'see-less') {
            this.see_more_secondary = 'see-more';
        }
        else {
            this.see_more_secondary = 'see-less';
        }
    };
    // /**
    //  * Each feature must have a different collapsed state to appear side by side
    //  * @param index - index of the feature in the list,
    //  * @returns an NgStyle object for the indexed feature
    //  */
    // INDRA_featureStyles(index: number): Object {
    // 	const iconWidth = 32;
    // 	if (this.state === 'collapsed') {
    // 		return { 'margin-left': iconWidth * index + 'px' };
    // 	} else {
    // 		return {};
    // 	}
    // }
    /**
     * Returns classes for each feature
     * @param feature - feature in the list,
     * @returns an NgClass object for the indexed feature
     */
    INDRAFeaturesListComponent.prototype.INDRA_featureClasses = function (feature) {
        var result = {
            'expanded': this.state === 'expanded',
            'collapsed': this.state === 'collapsed',
            'extras-feature--secondary': feature.secondary,
            'no-icon': !this.INDRA_hasIcon(feature)
        };
        if (feature.cssClass) {
            result[feature.cssClass] = true;
        }
        // to prevent multiple/continuous verbose warnings on console
        return Object.entries(result).filter(function (cur) { return cur[1]; }).map(function (cur) { return cur[0]; }).join(' ');
    };
    /**
     * Returns list of features
     * @returns list of features
     */
    INDRAFeaturesListComponent.prototype.INDRA_getFeatures = function () {
        this.totalFeaturesCount = this._features.length;
        return this._features;
    };
    INDRAFeaturesListComponent.prototype.INDRA_hasAnyBagPackSelected = function () {
        if (!this.bundle) {
            return false;
        }
        return this.bundle.INDRA_hasAnyBagPackSelected();
    };
    INDRAFeaturesListComponent.prototype.INDRA_getBagsbyPack = function () {
        if (!this.bundle) {
            return 0;
        }
        return this.bundle.INDRA_getBagsbyPack();
    };
    /**
     * Returns if feature has an icon to show
     * @param feature
     */
    INDRAFeaturesListComponent.prototype.INDRA_hasIcon = function (feature) {
        return feature.icon != null;
    };
    /**
     * Emits the @action of the feature to the parent
     * @param action
     */
    INDRAFeaturesListComponent.prototype.INDRA_handleOpenExtra = function (feature) {
        var action = feature.action;
        var extraInPack = this.bundle.extras_availables.find(function (e) { return e.id == feature.id; });
        if (extraInPack &&
            this.bundle &&
            this.bundle.INDRA_getPacksbyExtra(feature).length > 0
            && this.featureCount(feature) === 0) {
            this.modalService.assignComponent(INDRAPackModalComponent, { bundle: this.bundle, flight: this.flight, selectedExtra: feature.id });
            this.modalService.open();
        }
        else {
            this.INDRA_registerGAClickExtra(action);
            this.addFeature.emit(action);
        }
    };
    INDRAFeaturesListComponent.prototype.INDRA_registerGAClickExtra = function (action) {
        var ancillary = this._features.find(function (feature) { return feature.action.route === action.route; });
        var product = { code: ancillary.type };
        var eventDataLayerObject = this.gaService.IBE_createGA_AncillaryProducts(product, ancillary.name);
        eventDataLayerObject.actionField = this.gaService.INDRA_createGA_ActionField(EVENT_ACTION_CLICK);
        this.gaService.INDRA_GA_productClick(eventDataLayerObject, sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY));
    };
    /**
     * Emits the @details of the feature to the parent
     * @param details
     */
    INDRAFeaturesListComponent.prototype.INDRA_handleOpenExtraDetails = function (details) {
        this.detailsFeature.emit(details);
    };
    /**
     * Emits the call to open passenger-included sidebar to the parent
     */
    INDRAFeaturesListComponent.prototype.INDRA_handleOpenPassengerIncluded = function () {
        this.passengerIncluded.emit();
    };
    INDRAFeaturesListComponent.prototype.hasChanged = function (feature) {
        var featureChanged = new FeaturesMap(this.flight, this.featuresAdded).hasChanged(feature);
        if (featureChanged && feature.secondary && this.see_more_secondary === 'see-less' && !this.seeMoreDisplayed) {
            this.handleExtrasSeeMoreToggle();
            this.seeMoreDisplayed = true;
        }
        return featureChanged;
    };
    INDRAFeaturesListComponent.prototype.featureCost = function (feature) {
        /* // note: from Sprint 8 merge // TODO check if this needs to be implemented
        const extra = this.ancillariesAddedToPayWithMiles.find(item => {
            const featureLabel = feature.label.toLowerCase();
            const itemTofind = item.name.toLowerCase();
            if (featureLabel.indexOf(itemTofind) > -1) {
                this.payWithMiles = false;
                return item;
            }
        });
        if (extra) {
            this.payWithMiles = true;
            return this.TAP_formatMiles(extra.total);
        }
        return this.TAP_formatCash(new FeaturesMap(this.flight).getCost(feature));
        */
        return new FeaturesMap(this.flight, this.featuresAdded).getCost(feature);
    };
    INDRAFeaturesListComponent.prototype.featureCount = function (feature) {
        return new FeaturesMap(this.flight, this.featuresAdded).getCount(feature);
    };
    INDRAFeaturesListComponent.prototype.INDRA_getNoMeal = function () {
        return new FeaturesMap(this.flight, this.featuresAdded).executeMethod('meals', 'skip_count') == null ? 0 : new FeaturesMap(this.flight, this.featuresAdded).executeMethod('meals', 'skip_count');
    };
    INDRAFeaturesListComponent.prototype.itemCurrencyCode = function (feature) {
        if (feature.type == 'SEAT') {
            return (feature.currency ? feature.currency : this.itemsCurrencyCode);
        }
        else {
            return this.itemsCurrencyCode;
        }
    };
    INDRAFeaturesListComponent.prototype.INDRA_getSegmentIDs = function () {
        return this.flight.details.listSegment.map(function (segment) { return segment.idInfoSegment + ''; });
    };
    INDRAFeaturesListComponent.prototype.INDRA_getExtrasPrices = function () {
        var _this = this;
        var ancillariesCodes = {};
        if (this.flight && this.flight.details) {
            var priceFilter_1 = {
                idFlight: this.flight.details.idFlight,
                listSegmentId: this.INDRA_getSegmentIDs()
            };
            if (this.activeBookedTrip && this.activeBookedTrip['ancillaries-data']['bundleList']) {
                var bundleList = this.activeBookedTrip['ancillaries-data']['bundleList'];
                bundleList.forEach(function (bundleItem) {
                    bundleItem.ancillaryList.forEach(function (ancillaryItem) {
                        if (ancillaryItem && ancillaryItem.catalog && ancillaryItem.catalog.length > 0) {
                            ancillaryItem.catalog.forEach(function (catalogItem) {
                                var parsedFlightId = parseInt(catalogItem.flightId);
                                if (catalogItem.segmentId && parsedFlightId === priceFilter_1.idFlight
                                    && priceFilter_1.listSegmentId.includes(catalogItem.segmentId.toString())) {
                                    if (catalogItem.passengers.length > 0) {
                                        var isHighlight = catalogItem.passengers[0].codeList.some(function (item) { return item.isHighlight; }) != undefined ? catalogItem.passengers[0].codeList.some(function (item) { return item.isHighlight; }) : false;
                                        var prevItemPrices = catalogItem.passengers[0].codeList.map(function (item) { return Number(item.mnbPrice); });
                                        var hasMnbPrice = prevItemPrices.filter(function (price) { return !isNaN(price); }).length > 0;
                                        var itemPrices = catalogItem.passengers[0].codeList.map(function (item) { return Number(item.price); });
                                        var sum = itemPrices.reduce(function (total, amount) {
                                            return total + amount;
                                        }, 0.00);
                                        if (_this.hasUnaccompaniedMinor && !_this.allAreUnaccompaniedMinor
                                            && ancillaryItem.type === EXTRAS_ANCILLARY_SEAT) {
                                            ancillariesCodes[ancillaryItem.type] = { price: '0.00', previous_price: '', hasMnbPrice: hasMnbPrice, isHighlight: isHighlight };
                                        }
                                        else {
                                            var tempAncillaryPricetext = void 0;
                                            var tempAncillaryPrevPricetext = void 0;
                                            if (hasMnbPrice) {
                                                var minPriceIndex = _this.INDRA_getMinPriceIndex(itemPrices, prevItemPrices);
                                                tempAncillaryPricetext = (sum == Number(0.00) ? 'for free' : itemPrices[minPriceIndex].toString());
                                                tempAncillaryPrevPricetext = prevItemPrices[minPriceIndex].toString();
                                            }
                                            else {
                                                tempAncillaryPricetext = (sum == Number(0.00) ? 'for free' : Math.min.apply(Math, itemPrices).toString());
                                                tempAncillaryPrevPricetext = "";
                                            }
                                            if (ancillariesCodes[ancillaryItem.type]) {
                                                if (ancillariesCodes[ancillaryItem.type].price === 'for free') {
                                                    if (tempAncillaryPricetext !== 'for free') {
                                                        ancillariesCodes[ancillaryItem.type] = { price: tempAncillaryPricetext, previous_price: tempAncillaryPrevPricetext, hasMnbPrice: hasMnbPrice, isHighlight: isHighlight };
                                                    }
                                                }
                                                // If highlight available for either segment of bound, set to true
                                                // Highlight should be shown when at least 1 segment contains it
                                                if (!ancillariesCodes[ancillaryItem.type].isHighlight && isHighlight) {
                                                    ancillariesCodes[ancillaryItem.type].isHighlight = isHighlight;
                                                }
                                            }
                                            else {
                                                ancillariesCodes[ancillaryItem.type] = { price: tempAncillaryPricetext, previous_price: tempAncillaryPrevPricetext, hasMnbPrice: hasMnbPrice, isHighlight: isHighlight };
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    });
                });
            }
        }
        this.ancillariesPrices = ancillariesCodes;
        this.featuresLoaded = true;
    };
    INDRAFeaturesListComponent.prototype.INDRA_isHighlight = function (feature) {
        if (this.ancillariesPrices[feature.type] && this.ancillariesPrices[feature.type].isHighlight) {
            return 'highlight';
        }
        else {
            return '';
        }
    };
    INDRAFeaturesListComponent.prototype.INDRA_getMinPriceIndex = function (itemPrices, prevItemPrices) {
        var availableIndexes = [];
        var lowestPrice;
        var lowestPriceIndex;
        prevItemPrices.forEach(function (value, index) {
            if (!isNaN(value)) {
                availableIndexes.push(index);
            }
        });
        availableIndexes.forEach(function (value, index) {
            if ((itemPrices[value] < lowestPrice || index === 0)) {
                lowestPrice = itemPrices[value];
                lowestPriceIndex = value;
            }
        });
        return lowestPriceIndex;
    };
    INDRAFeaturesListComponent.prototype.INDRA_checkIsNaN = function (value) {
        return isNaN(value);
    };
    INDRAFeaturesListComponent.prototype.INDRA_getStatusKey = function (statusCode) {
        this.ancillariesShoppingCart.INDRA_getStatusKey(statusCode);
    };
    INDRAFeaturesListComponent.prototype.INDRA_checkIfUnconfirmed = function (feature) {
        if (!feature.unconfirmed || feature.unconfirmed.length < 1) {
            return false;
        }
        return true;
    };
    INDRAFeaturesListComponent.prototype.INDRA_loadFeatures = function () {
        this.filteredPrimaryFeatures = this.INDRA_getFeatures();
        // At this moment we're just sending impressions from catalog when add more sidebars are open
        // this.INDRA_sendGAImpressions();
    };
    INDRAFeaturesListComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRAFeaturesListComponent.prototype.INDRA_sendGAImpressions = function () {
        var brand = null;
        if (this.flight && this.flight.details && this.flight.details.fareFamily) {
            brand = this.bookingService.INDRA_getBrandCode(this.flight.details.fareFamily);
        }
        if (this.filteredPrimaryFeatures.length > 0) {
            this.filteredPrimaryFeatures.forEach(function (item, index) {
                var product = {
                    id: item.type,
                    name: item.name,
                    list: (item.action ? item.type : 'What\'s included list'),
                    brand: brand,
                    category: 'Ancillaries',
                    position: index + 1,
                };
                // if (item.action)
                // this.googleAnalytics.INDRA_addImpression(product);
            });
            // this.googleAnalytics.INDRA_sendEvent(EVENT_CATEGORY_ANCILLARIES, EVENT_LABEL_EC, EVENT_ACTION_IMPRESSION);
        }
        else {
        }
    };
    INDRAFeaturesListComponent.prototype.INDRA_ancillariesWhitelist = function (selectedPacks, flightId, bundleList) {
        var ancillariesOnOtherSegment = [];
        var selectedPackAncillaries = [];
        // Gather all ancillaries added on packs for all segments
        selectedPacks.forEach(function (pack) {
            if (!selectedPackAncillaries[pack.segmentId]) {
                selectedPackAncillaries[pack.segmentId] = [];
                pack.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(function (ancillary) {
                    if (!selectedPackAncillaries[pack.segmentId].includes(ancillary.type) && ![EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_BAG, EXTRAS_ANCILLARY_EQUIPMENT].includes(ancillary.type)) {
                        selectedPackAncillaries[pack.segmentId].push(ancillary.type);
                    }
                });
            }
            else {
                pack.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(function (ancillary) {
                    if (!selectedPackAncillaries[pack.segmentId].includes(ancillary.type) && ![EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_BAG, EXTRAS_ANCILLARY_EQUIPMENT].includes(ancillary.type)) {
                        selectedPackAncillaries[pack.segmentId].push(ancillary.type);
                    }
                });
            }
        });
        bundleList.forEach(function (bundle) {
            if (bundle.ancillaryList[0].catalog) {
                bundle.ancillaryList[0].catalog.forEach(function (catalog) {
                    if (catalog.flightId === flightId) {
                        if (!selectedPackAncillaries[catalog.segmentId] || !selectedPackAncillaries[catalog.segmentId].includes(bundle.ancillaryList[0].type)) {
                            // If ancillary not added in pack, push to whitelist
                            ancillariesOnOtherSegment.push({
                                type: bundle.ancillaryList[0].type,
                                element: catalog
                            });
                            var element = document.getElementById(bundle.ancillaryList[0].type + "_" + flightId);
                            if (element) {
                                element.style.display = '';
                            }
                        }
                        else if (ancillariesOnOtherSegment.findIndex(function (anc) { return anc.type === bundle.ancillaryList[0].type; }) === -1) {
                            // If ancillary added by pack for all segments, hide from view
                            var element = document.getElementById(bundle.ancillaryList[0].type + "_" + flightId);
                            if (element) {
                                element.style.display = 'none';
                            }
                        }
                    }
                });
            }
        });
        return ancillariesOnOtherSegment;
    };
    return INDRAFeaturesListComponent;
}(FeaturesListComponent));
export { INDRAFeaturesListComponent };
var FeaturesMap = /** @class */ (function () {
    function FeaturesMap(flight, featuresAdded) {
        this.propertiesMapping = {
            seats: {
                changed: this.seatsChanged,
                count: this.seatCount,
                cost: this.seatCosts
            },
            bags: {
                changed: this.bagsChanged,
                count: this.bagsCount,
                cost: this.bagsCost,
            },
            fasttrack: {
                changed: this.fastTrackChanged,
                count: this.fastTrackCount,
                cost: this.fastTrackCost,
            },
            lounge: {
                changed: this.loungeChanged,
                count: this.loungeCount,
                cost: this.loungeCost,
            },
            sports: {
                changed: this.sportsChanged,
                count: this.sportsCount,
                cost: this.sportsCost,
            },
            instruments: {
                changed: this.instrumentsChanged,
                count: this.instrumentsCount,
                cost: this.instrumentsCost,
            },
            pets: {
                changed: this.petsChanged,
                count: this.petsCount,
                cost: this.petsCost,
            },
            meals: {
                changed: this.mealsChanged,
                count: this.mealsCount,
                cost: this.mealsCost,
                skip_count: this.skipCount
            },
            musical: {
                changed: this.musicalChanged,
                count: this.musicalCount,
                cost: this.musicalCost,
            },
            prefBoard: {
                changed: this.prefBoardChanged,
                count: this.prefBoardCount,
                cost: this.prefBoardCost,
            },
        };
        this.flight = flight;
        this.featuresAdded = featuresAdded;
    }
    FeaturesMap.prototype.getCost = function (feature) {
        return this.flight ? this.propertiesMapping[feature.id].cost.apply(this) : 0;
    };
    FeaturesMap.prototype.hasChanged = function (feature) {
        return this.flight ? this.propertiesMapping[feature.id].changed.apply(this) : false;
    };
    FeaturesMap.prototype.getCount = function (feature) {
        return this.flight ? this.propertiesMapping[feature.id].count.apply(this) : 0;
    };
    /**
     * @param featureId string Any key of propertiesMapping
     * @param prop string Any property on any object in propertiesMapping
     * @return outcome after executing any method linked with prop
     */
    FeaturesMap.prototype.executeMethod = function (featureId, prop) {
        var property = this.propertiesMapping[featureId];
        var keyProp = prop;
        return this.flight && property ? property[keyProp].apply(this) : null;
    };
    FeaturesMap.prototype.seatsChanged = function () {
        return this.seatCount() > 0;
    };
    FeaturesMap.prototype.seatCount = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_SEAT ? 1 : 0); }), 0);
    };
    FeaturesMap.prototype.seatCosts = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_SEAT ? parseFloat(item.price.toString()) : 0); }), 0);
    };
    FeaturesMap.prototype.bagsChanged = function () {
        return this.bagsCount() > 0;
    };
    FeaturesMap.prototype.bagsCount = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_BAG ? 1 : 0); }), 0);
    };
    FeaturesMap.prototype.bagsCost = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_BAG ? parseFloat(item.price.toString()) : 0); }), 0);
    };
    FeaturesMap.prototype.fastTrackChanged = function () {
        return this.fastTrackCount() > 0;
    };
    FeaturesMap.prototype.fastTrackCount = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_FAST_TRACK ? 1 : 0); }), 0);
    };
    FeaturesMap.prototype.fastTrackCost = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_FAST_TRACK ? parseFloat(item.price.toString()) : 0); }), 0);
    };
    FeaturesMap.prototype.loungeChanged = function () {
        return this.loungeCount() > 0;
    };
    FeaturesMap.prototype.loungeCount = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_LOUNGE ? 1 : 0); }), 0);
    };
    FeaturesMap.prototype.loungeCost = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_LOUNGE ? parseFloat(item.price.toString()) : 0); }), 0);
    };
    FeaturesMap.prototype.sportsChanged = function () {
        return this.sportsCount() > 0;
    };
    FeaturesMap.prototype.sportsCount = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_EQUIPMENT ? 1 : 0); }), 0);
    };
    FeaturesMap.prototype.sportsCost = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_EQUIPMENT ? parseFloat(item.price.toString()) : 0); }), 0);
    };
    FeaturesMap.prototype.instrumentsChanged = function () {
        return this.instrumentsCount() > 0;
    };
    FeaturesMap.prototype.instrumentsCount = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_MUSICAL ? 1 : 0); }), 0);
    };
    FeaturesMap.prototype.instrumentsCost = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_MUSICAL ? parseFloat(item.price.toString()) : 0); }), 0);
    };
    FeaturesMap.prototype.petsChanged = function () {
        return this.petsCount() > 0;
    };
    FeaturesMap.prototype.petsCount = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_ANIMAL ? 1 : 0); }), 0);
    };
    FeaturesMap.prototype.petsCost = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_ANIMAL ? parseFloat(item.price.toString()) : 0); }), 0);
    };
    FeaturesMap.prototype.mealsChanged = function () {
        return this.mealsCount() > 0;
    };
    FeaturesMap.prototype.mealsCount = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_MEAL ? 1 : 0); }), 0);
    };
    FeaturesMap.prototype.mealsCost = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_MEAL ? parseFloat(item.price.toString()) : 0); }), 0);
    };
    FeaturesMap.prototype.skipCount = function () {
        /**
         * Get the first stop and duplicate infor for other flights
         */
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.code === SSR_CODE_MEAL_SKIP ? 1 : 0); }), 0);
    };
    // MUSCIAL
    FeaturesMap.prototype.musicalChanged = function () {
        return this.musicalCount() > 0;
    };
    FeaturesMap.prototype.musicalCount = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_MUSICAL ? 1 : 0); }), 0);
    };
    FeaturesMap.prototype.musicalCost = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_MUSICAL ? parseFloat(item.price.toString()) : 0); }), 0);
    };
    FeaturesMap.prototype.prefBoardChanged = function () {
        return this.prefBoardCount() > 0;
    };
    FeaturesMap.prototype.prefBoardCount = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_PREF_BOARD ? 1 : 0); }), 0);
    };
    FeaturesMap.prototype.prefBoardCost = function () {
        return this.featuresAdded.reduce((function (sum, item) { return sum + (item.type === EXTRAS_ANCILLARY_PREF_BOARD ? parseFloat(item.price.toString()) : 0); }), 0);
    };
    return FeaturesMap;
}());
